import { render, staticRenderFns } from "./ProjectSimpleData.vue?vue&type=template&id=5c1762d0"
import script from "./ProjectSimpleData.vue?vue&type=script&lang=js"
export * from "./ProjectSimpleData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports